// extracted by css-extract-rspack-plugin
export default {"grid":"grid--HZ0qZACdGczQex_n","card":"card--ZObiEKBSMFcRSMEJ","placeholder":"placeholder--mkpD5Sc750b9aim8","large":"large--REA7cXxNms8CMVCh"};